import { gql } from '@apollo/client'
import { useFeatureFlags } from '@npco/mp-utils-mp-feature-flags'
import { useTranslations } from '@npco/utils-translations'

import { savingsAccountBannerTranslations } from '../SavingsAccountBanner.i18n'
import { EmphasisEntitySavingsAccountProductFragment } from './Emphasis.generated'
import * as styled from './Emphasis.styled'

type EmphasisProps = {
  entitySavingsAccountProduct: EmphasisEntitySavingsAccountProductFragment
}

export const Emphasis = ({ entitySavingsAccountProduct }: EmphasisProps) => {
  const flags = useFeatureFlags()
  const t = useTranslations(savingsAccountBannerTranslations)

  if (flags.SavingsAccountMay) {
    return (
      <styled.EmphasisPill>
        <styled.Interest>
          {t('mayInterest', {
            effectiveInterestRate:
              entitySavingsAccountProduct.effectiveInterestRate,
          })}
        </styled.Interest>
        <styled.Pa>{t('pa')}</styled.Pa>
        <styled.MayAsterisk>{t('asterisk')}</styled.MayAsterisk>
      </styled.EmphasisPill>
    )
  }

  return (
    <styled.Emphasis>
      {t('emphasis', {
        effectiveInterestRate:
          entitySavingsAccountProduct.effectiveInterestRate,
        asterisk: <styled.Asterisk>{t('asterisk')}</styled.Asterisk>,
      })}
    </styled.Emphasis>
  )
}

Emphasis.fragments = {
  EntitySavingsAccountProduct: gql`
    fragment EmphasisEntitySavingsAccountProductFragment on EntitySavingsAccountProduct {
      effectiveInterestRate
    }
  `,
}
